// MWC Watch Detail - Main orchestration file
// Initializes the watch detail page, loads watch/master data and routes user events to modules.
// This file should stay small and load after all mwc-watch-detail-* modules.

(function () {

  if (window.mwcWatchDetailInitialized) return;
  window.mwcWatchDetailInitialized = true;

  document.addEventListener("mwc:authenticated", init);

  window.MWCWatchDetailReload = init;

  function getWatchId() {
    return window.MWCWatchDetailUtils.getWatchId();
  }

  function renderEmpty(message) {
    window.MWCWatchDetailUtils.renderEmpty(message);
  }

function renderWatch(watch, masterWatch) {
  const root = document.getElementById("mwc-watch-detail");
  if (!root) return;

  const photoHtml = window.MWCWatchDetailRender.renderPhotoHtml(watch);

  const templateEl = document.getElementById("mwc-watch-detail-template");

  if (!templateEl) {
    renderEmpty("Template not found.");
    return;
  }

  const template = templateEl.innerHTML;

const displayHelpers = window.MWCWatchDetailRender.createDisplayHelpers(
  watch,
  masterWatch
);

const isCustomValue = displayHelpers.isCustomValue;

root.innerHTML = window.MWCWatchDetailRender.renderTemplateHtml(
  template,
  watch,
  photoHtml,
  displayHelpers
);

  // Highlight custom values
  const fields = root.querySelectorAll("[data-mwc-field-key]");

  fields.forEach(function (el) {
    const field = el.getAttribute("data-mwc-field-key");
    
    if (isCustomValue(field)) {
      el.classList.remove("text-subdued");
      el.classList.add("mwc-field-custom");
    }
  });

  }



  async function init(e) {
    const id = getWatchId();
    if (window.mwcWatchDetailLoaded) return;
    window.mwcWatchDetailLoaded = true;
  
  if (!id) {
  const constants = window.MWCWatchDetailConstants || {};
  const routes = constants.routes || {};

  window.location.href = routes.myWatches || "/pages/my-watches";
  return;
}


    try {
      const data = await MWC.getMyWatches();

      const watch = data.find(function (w) {
        return w.id === id;
      });

      if (!watch) {
        renderEmpty();
        return;
      }

    let masterWatch = null;

if (watch.watch_id) {
  try {
    const response = await MWC.getWatch({
      id: watch.watch_id
    });


    masterWatch = response?.watch || null;

  } catch (e) {
    console.error("Failed to load master watch", e);
    masterWatch = null;
  }
}


    renderWatch(watch, masterWatch);

    if (window.MWCWatchDetailRecommendations) {
      await window.MWCWatchDetailRecommendations.render(watch);
    }

    const root = document.getElementById("mwc-watch-detail");

    if (root) {
      root.removeEventListener("change", onChange);
      root.addEventListener("change", onChange);
    }

    document.removeEventListener("click", onClick);
    document.addEventListener("click", onClick);

    } catch (e) {
      renderEmpty();
    }
  }

    async function onChange(e) {
      const uploadInput = e.target.closest("[data-mwc-upload-photos]");

      if (!uploadInput) {
        return;
      }

      const watchId = getWatchId();

      await window.MWCWatchDetailPhotos.uploadPhotos(uploadInput, watchId);
    }

    function cancelActiveFieldEdit() {
      return window.MWCWatchDetailFields.cancelActiveFieldEdit();
    }



    async function onClick(e) {
      const detailRoot = document.getElementById("mwc-watch-detail");
      const isUploadInput = e.target.matches("[data-mwc-upload-photos]");


    const activeSaveBtn = document.querySelector(".mwc-row-edit-button[data-mwc-save-field]");

    if (activeSaveBtn && !activeSaveBtn.contains(e.target)) {
      const activeRow = activeSaveBtn.closest("tr");

      if (activeRow && !activeRow.contains(e.target)) {
        cancelActiveFieldEdit();
      }
    }




      if (!isUploadInput && (!detailRoot || !detailRoot.contains(e.target))) {
        return;
      }

      
  const deleteBtn = e.target.closest("[data-mwc-delete-watch]");

  const setMainPhotoBtn = e.target.closest("[data-mwc-set-main-photo-disabled]");

  if (setMainPhotoBtn) {
    const photoUrl = setMainPhotoBtn.getAttribute("data-mwc-set-main-photo-disabled");
    const watchId = getWatchId();

    await window.MWCWatchDetailPhotos.setMainPhoto(photoUrl, watchId);
    return;
  }


  const deletePhotoBtn = e.target.closest("[data-mwc-delete-photo]");

  if (deletePhotoBtn) {
    const photoUrl = deletePhotoBtn.getAttribute("data-mwc-delete-photo");
    const watchId = getWatchId();

    await window.MWCWatchDetailPhotos.deletePhoto(photoUrl, watchId);
    return;
  }

    const thumbBtn = e.target.closest("[data-mwc-thumb]");

  if (thumbBtn) {
    window.MWCWatchDetailPhotos.selectThumbnail(thumbBtn);
    return;
  }
  const openEditGroupBtn = e.target.closest("[data-mwc-open-edit-group]");
  const closeEditGroupBtn = e.target.closest("[data-mwc-close-edit-group]");

  if (openEditGroupBtn) {
    e.preventDefault();
    e.stopPropagation();

    const group = openEditGroupBtn.getAttribute("data-mwc-open-edit-group");

    const confirmed = window.confirm(
      "If you think some of this information is incorrect, you can edit the fields in this section and save your changes. Do you want to continue?"
    );

    if (!confirmed) {
      return;
    }

    const detailsEl = openEditGroupBtn.closest("details");
    const viewEl = document.querySelector('[data-mwc-group-view="' + group + '"]');
    const editEl = document.querySelector('[data-mwc-group-edit="' + group + '"]');

    if (detailsEl) detailsEl.open = true;
    if (viewEl) viewEl.style.display = "none";
    if (editEl) editEl.style.display = "block";

    return;
  }

  if (closeEditGroupBtn) {
    const group = closeEditGroupBtn.getAttribute("data-mwc-close-edit-group");

    const viewEl = document.querySelector('[data-mwc-group-view="' + group + '"]');
    const editEl = document.querySelector('[data-mwc-group-edit="' + group + '"]');

    if (viewEl) viewEl.style.display = "block";
    if (editEl) editEl.style.display = "none";

    return;
  }



  const editFieldBtn = e.target.closest("[data-mwc-edit-field]");

  if (editFieldBtn) {
    window.MWCWatchDetailFields.startFieldEdit(editFieldBtn);
    return;
  }

  const resetFieldBtn = e.target.closest("[data-mwc-reset-field]");

  if (resetFieldBtn) {
    window.MWCWatchDetailFields.resetField(resetFieldBtn);
    return;
  }

  const saveFieldBtn = e.target.closest("[data-mwc-save-field]");

  if (saveFieldBtn) {
    await window.MWCWatchDetailFields.saveField(saveFieldBtn);
    return;
  }

  const reportBtn = e.target.closest("[data-mwc-report]");

  if (reportBtn) {
    await window.MWCWatchDetailFields.reportField(reportBtn);
    return;
  }

  if (deleteBtn) {
    const id = deleteBtn.getAttribute("data-mwc-delete-watch");

    await MWC.deleteWatch({
      id
    });

    window.location.href = "/pages/my-watches";

  }




}

})();